export enum AnimType {
	COPY = 'copy',
	EASING = 'easing',
	PLAY = 'play',
	TARGET = 'target',
}
